<div class="loading-screen-wrapper">
  <div class="loading-screen-icon">
    <mat-spinner></mat-spinner>
    <span *ngIf="textLoading">Estamos procesando tu información</span>
  </div>
</div>
